import {
  isAnnounced,
  isFundRaising,
  isLoanPayment,
  isPaid,
  isRefunded,
  PackageStatus,
  ProjectStatus,
} from 'api-client';

export type StatusBadgeTone = 'green' | 'default' | 'muted' | 'yellow';

export const getPackageStatusTone = (status: PackageStatus): StatusBadgeTone => {
  if (status === PackageStatus.FORMING) {
    return 'green';
  }

  if (status === PackageStatus.CLOSED) {
    return 'muted';
  }

  return 'default';
};

export const getProjectStatusTone = (status: ProjectStatus): StatusBadgeTone => {
  if (isFundRaising(status)) {
    return 'green';
  }

  if (isPaid(status) || isRefunded(status)) {
    return 'muted';
  }

  if (isLoanPayment(status)) {
    return 'default';
  }

  if (isAnnounced(status)) {
    return 'yellow';
  }

  return 'default';
};

export const getProjectStatusBadgeLabel = (status: ProjectStatus): string => {
  if (isFundRaising(status)) {
    return 'СБОР СРЕДСТВ';
  }

  if (isLoanPayment(status)) {
    return 'ТЕКУЩИЙ';
  }

  if (isPaid(status)) {
    return 'ЗАВЕРШЕН';
  }

  if (isRefunded(status)) {
    return 'ОТМЕНЕН';
  }

  return 'АНОНСИРОВАН';
};
